import { render, staticRenderFns } from "./DatosSocioeconomicos.vue?vue&type=template&id=35d08872&scoped=true&"
import script from "./DatosSocioeconomicos.vue?vue&type=script&lang=js&"
export * from "./DatosSocioeconomicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d08872",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/DatosSocioeconomicos.vue
// module id = 654
// module chunks = 5